// 手机号校验  产品要求1开头的11位数字
export function phoneNumValid(phoneNumber) {
  const reg = /^1\d{10}$/;
  return reg.test(phoneNumber);
}
//判断验证码 6位
export function CodeValid(str) {
  const reg = /^\d{6}$/;
  return reg.test(str);
}
//全为空格的校验

export function allBlankSpaceValid(Space) {
  const reg = /^\s+$/g;
  return Space.match(reg);
}
// 邮箱校验
export function emailValid(email) {
  const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  return reg.test(email);
}
// 手机号脱敏
export function mobileDesensitization(mobile) {
  if (!phoneNumValid(mobile)) return mobile;
  return mobile.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
}

// 邮箱脱敏
export function emailDesensitization(email) {
  if (!emailValid(email)) return email;
  const head_reg = new RegExp(/^[\s\S]{0,3}/);
  const tail_reg = new RegExp(/@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/);
  const head = email.match(head_reg)[0];
  const tail = email.match(tail_reg)[0];
  return head + "****" + tail;
}
